import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row } from 'antd';
import { FormField, Upload } from 'components';
import { useForm } from 'antd/lib/form/Form';
import { content} from './content';
import NoResults from 'pages/appTrack/page1/components/NoResults';
import { isBeneficiary ,isProvider } from 'utils';
import { updateFormField } from 'store/forms/actions';
import { omit } from 'lodash';
import { flattenDocs } from '../../utils';
import { DownloadedItems } from '..';

const DocsInvestor = ({ group }) => {

  const [form] = useForm();
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const isViewMode = useSelector(state => state.forms.carrier.viewMode); 
  const viewMode = (isViewMode || !isBeneficiary(user?.groups));
  const ownerStatus = useSelector(state => state.forms.carrier.ownerStatus);
  const residence = useSelector(state => state.forms.carrier.residence);
  const ameaMember = useSelector(state => state.forms.carrier.ameaMember);  
  const docs = useSelector(state => state.forms['documents']);
  const flatDocs = flattenDocs(docs);
  const legalChildren = useSelector(state => state.forms.carrier.legalChildren);

  return (
    <div className='mt-1'>
          {content(ownerStatus, ameaMember, residence, legalChildren).map((item, index) => {
            return (
              <Upload item={item} subFileCode={item.fileCode} key={index} group={'documents'} />
            );
          })}
        </div>
      ) 
};

DocsInvestor.propTypes = {
  group: PropTypes.string.isRequired,
};

export default DocsInvestor;
